<template>
  <div
    :class="{ 'visible': isOpen }"
    class="modal-wrapper"
  >
    <div class="modal">
      <div class="modal-header">
        <h2 class="is-size-5">
          Invite Judge
        </h2>
      </div>
      <div class="modal-body">
        <div class="columns">
          <div class="column">
            <TextField
              :label="'Email'"
              :type="'email'"
              :placeholder="'example@example.com'"
              :message="emailMessage"
              :extraClass="emailMessage ? emailMessage.class : ''"
              @keypress="saveEmail"
            />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <a
          href="#"
          class="button is-light"
          @click.prevent="closeModal(false)"
        >Cancel</a>
        <a
          href="#"
          :class="{ 'is-loading': submitting }"
          class="button is-warning has-text-weight-bold"
          :disabled="!isValid || submitting"
          @click.prevent="submitForm"
        >
          Send invite
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import TextField from '@/components/inputs/TextField'
import inputMessages from '@/configs/inputMessages'
import emailValidator from 'email-validator'

export default {
  name: 'EditDivision',
  components: {
    TextField
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'create'
    }
  },
  data () {
    return {
      //  Values
      email: '',
      //  Errors
      emailMessage: false,
      //  State
      isValid: false,
      submitting: false

    }
  },
  methods: {
    saveEmail (value) {
      if (value.trim().length > 0) {
        if (emailValidator.validate(value)) {
          this.emailMessage = false
          this.email = value
          this.isValid = true
        } else {
          this.emailMessage = inputMessages.emailFormat
          this.isValid = false
        }
      } else {
        this.emailMessage = inputMessages.required
        this.isValid = false
      }
    },
    submitForm () {
      if (this.isValid) {

        let data = {
          email: this.email
        }

        this.$store
          .dispatch('invites/SEND_INVITE', data)
          .then(res => {
            this.submitting = false
            this.$toasted.success('Judge invite sent')
            this.closeModal(true)
          })
          .catch(err => {
            this.submitting = false
            this.$toasted.error('Error sending judge invite')
            console.log(err)
          })
      }
    },
    closeModal (refresh) {
      this.$emit('closeModal', refresh)
    }
  }
}
</script>
